var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-icon',{attrs:{"color":_vm.color_code}},[_vm._v(" mdi-checkbox-blank ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }